import { createSelector } from 'reselect';

const getGroups = (state) => state.groups || [];
const getActiveGroupId = (state) => state.groupId || (state.groups.length > 0 ? state.groups[0].id : null);

export const getActiveGroup = createSelector(getGroups, getActiveGroupId, (groups, groupId) =>
  groups.filter((g) => g.id === groupId)
);
